import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { therapyPlanningAction } from 'src/redux/actions/constant';
import therapyPlanningService from '../../../../services/apiServices/therapyPlanning/therapyPlanning';
import { updateDiscipleByMap } from 'src/components/therapyPlanning_2.0/commonComponent/updateSingleCellData';

const {
  APPLY_THERAPY_TEMPLATES_REQUEST_2_0,
  APPLY_THERAPY_TEMPLATES_SUCCESS_2_0,
  APPLY_THERAPY_TEMPLATES_FAILURE_2_0,
  APPLY_THERAPY_TEMPLATES_LOADING_2_0,
  APPLY_THERAPY_TEMPLATES_RESET_2_0,
} = therapyPlanningAction;

function* applyTheTherapyTemplates(payload: any): SagaReturnType<any> {
  try {
    yield put({ type: APPLY_THERAPY_TEMPLATES_LOADING_2_0 });
    const response = yield call(therapyPlanningService.applyTherapyTemplates, payload?.payload);
    if (response?.status === 200) {
      yield put({
        type: APPLY_THERAPY_TEMPLATES_SUCCESS_2_0,
        payload: response?.data?.message,
      });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: APPLY_THERAPY_TEMPLATES_FAILURE_2_0, payload: error });
  }
}

function* applyTheTherapyTemplatesSaga() {
  yield takeEvery(APPLY_THERAPY_TEMPLATES_REQUEST_2_0, applyTheTherapyTemplates);
}

export default applyTheTherapyTemplatesSaga;
